import { render, staticRenderFns } from "./DifyChatbot.vue?vue&type=template&id=2f0ea64e&"
import script from "./DifyChatbot.vue?vue&type=script&lang=js&"
export * from "./DifyChatbot.vue?vue&type=script&lang=js&"
import style0 from "./DifyChatbot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DifyChatbot.vue"
export default component.exports